import BulbIcon from 'components/CommonUI/svgIcons/devicesIcon/BulbIcon'
import LaptopIcon from 'components/CommonUI/svgIcons/devicesIcon/LaptopIcon'
import LightningIcon from 'components/CommonUI/svgIcons/devicesIcon/LightningIcon'
import ModemIcon from 'components/CommonUI/svgIcons/devicesIcon/ModemIcon'
import GearIcon from 'components/CommonUI/svgIcons/devicesIcon/GearIcon'
import PlugIcon from 'components/CommonUI/svgIcons/devicesIcon/PlugIcon'
import FanIcon from 'components/CommonUI/svgIcons/devicesIcon/FanIcon'

export const devicesIconComponent = {
  lightbulb: {
    ComponentIcon: BulbIcon,
  },
  laptop: {
    ComponentIcon: LaptopIcon,
  },
  lightning: {
    ComponentIcon: LightningIcon,
  },
  modem: {
    ComponentIcon: ModemIcon,
  },
  gear: {
    ComponentIcon: GearIcon,
  },
  plug: {
    ComponentIcon: PlugIcon,
  },
  fan: {
    ComponentIcon: FanIcon,
  },
}

// const devicesIconName = [
//   'lightbulb',
//   'laptop',
//   'lightning',
//   'modem',
//   'gear',
//   'plug',
//   'fan',
// ]
